function throttle(func, ms = 32) {
    let isThrottled = false,
        savedArgs,
        savedThis;

    function wrapper() {
        if (isThrottled) {
            savedArgs = arguments;
            savedThis = this;
            return;
        }

        func.apply(this, arguments);

        isThrottled = true;

        setTimeout(function () {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(savedThis, savedArgs);
                savedArgs = savedThis = null;
            }
        }, ms);
    }

    return wrapper;
}

document.addEventListener(
    'DOMContentLoaded',
    () => {
        window._header.show();
        document.querySelector('main .sec-title').classList.remove('hide');

        let root = document.getElementById('root-media');

        let cases = [],
            renderCount = 0;

        let handlerScroll = throttle(() => {
            if (checkScrollForRender()) {
                renderCases(6);
            }
        }, 100);

        setTimeout(() => {
            getCases().then((data) => {
                if (data.cases) {
                    cases = data.cases;
                    renderCases(6);

                    if (cases.length === 0) {
                        root.textContent = 'Sorry, no cases yet';
                    } else {
                        window.addEventListener('scroll', handlerScroll);
                    }
                } else {
                    root.textContent =
                        'Sorry, there might have been an error. Reload the page';
                    console.warn('Required data not received');
                }
            });
        }, 500);

        function getCases() {
            return fetch('/api/media/cases').then(
                (response) => response.json(),
                (error) => console.error(error),
            );
        }

        function renderCases(count = 3) {
            if (renderCount === cases.length) {
                window.removeEventListener('scroll', handlerScroll);
            }

            if (renderCount + count > cases.length) {
                count = cases.length - renderCount;
            }

            let index = 0;

            for (let i = renderCount; i < renderCount + count; i++) {
                let a = document.createElement('a');
                a.className = 'media hide';
                a.href = cases[i].pdf;
                a.insertAdjacentHTML(
                    'afterbegin',
                    `<div class="media-image">
                                                    <img src="${cases[i].logo}" alt="">
                                                </div>
                                                <p class="media-title">${cases[i].title}</p>
                                                `,
                );
                root.append(a);
                setTimeout(() => a.classList.remove('hide'), 300 * index);
                index++;
            }
            renderCount += count;
        }

        function checkScrollForRender() {
            let coordY =
                window.pageYOffset + document.documentElement.clientHeight;
            let scrollHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.body.clientHeight,
                document.documentElement.clientHeight,
            );
            if (coordY >= scrollHeight - 100) {
                return true;
            } else {
                return false;
            }
        }
    },
    { once: true },
);
